var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SurfacePostsDraggablePad,{ref:_setup.assignRootElementRef,class:[
    'flex',
    'flex-row',

    'space-s-3 tablet-portrait:space-s-4',

    // Removing overflow classes increase document.documentElement.scrollWidth and allows full screenshot with full_width param
    !_setup.isScreenshotMode && 'overflow-y-hidden overflow-x-auto',
    {
      'scrollbar-photo': _setup.backgroundLuminance === 'light',
      'scrollbar-photo-dark': _setup.backgroundLuminance === 'dark',
    },
    'mx-auto',
    'box-border',
    'w-full',
    'px-3 tablet-portrait:px-4',
  ],attrs:{"dir":_setup.dir}},[_vm._l((_setup.sortedGroups),function(group){return _c('section',{key:group.id,class:[
      'relative',
      'flex-none',
      'flex',
      'flex-col',
      // This list of sections should be centered on the screen.
      // Normally, we can do it with `justify-center` inside a
      // flex container. But since the content can overflow
      // horizontally, we can't use it but instead need to
      // set `margin-left: auto` and `margin-right: auto` on the
      // first and last elements respectively.
      // See: https://stackoverflow.com/a/24678299/8943850
      'first:!ms-auto',
      'last:!me-auto',
      _setup.isPostSizeStandard && 'w-64',
      _setup.isPostSizeWide && 'w-95',
      {
        'surface-section': _setup.wishGroupBy === _setup.GroupByTypes.Section,
      },
    ],attrs:{"id":'section-' + group.id,"data-id":group.id,"data-rank":group.sort_index}},[(_setup.canShowDraggingOverlayOnGroup(group.id))?_c('div',{class:[
        'absolute -ms-2 z-underneath',
        'border-solid border-2 rounded-xl shadow-elevation-2',
        'pointer-events-none',
        {
          'border-grape-500 bg-modal-overlay-grape-alpha-20': _setup.backgroundLuminance === 'light',
          'border-canary-500 bg-modal-overlay-canary-alpha-20': _setup.backgroundLuminance === 'dark',
        },
      ],style:({ height: `calc(100% + 8px)`, width: `${_setup.overlayWidth}px`, top: `${_setup.overlayTopPosition}px` })}):_vm._e(),_vm._v(" "),(_setup.wishGroupBy !== _setup.GroupByTypes.None)?_c('div',{class:[
        'flex-none flex flex-col justify-end mb-3 tablet-portrait:mb-4 mt-2',
        _setup.isPostSizeStandard && 'max-w-64',
        _setup.isPostSizeWide && 'max-w-95',
      ],style:({ height: `${_setup.maxPostGroupHeaderHeight}px` })},[(_setup.wishGroupBy === _setup.GroupByTypes.Section)?_c(_setup.SurfacePostGroupHeaderSection,{attrs:{"section":group},on:{"resize":function($event){return _setup.updateMaxGroupHeaderHeight(group.id, $event)},"before-unmount":function($event){return _setup.vDel(_setup.postGroupHeaderHeights, group.id)}}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{class:[
        'flex-grow',
        'flex',
        'flex-col',
        'space-y-2',
        'overflow-y-auto',
        'overflow-x-hidden',
        'group-posts',
        '-ms-1.5 ps-1.5',
        {
          'scrollbar-photo': _setup.backgroundLuminance === 'light',
          'scrollbar-photo-dark': _setup.backgroundLuminance === 'dark',
        },
      ],attrs:{"id":`group-posts-${group.id}`,"data-id":group.id},on:{"scroll":_setup.handleGroupScroll}},_vm._l((_setup.allSortedPostsByGroup[group.id]),function(post,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_setup.shouldDisplayPost(post.cid)),expression:"shouldDisplayPost(post.cid)"}],key:post.cid,staticClass:"wish-wrapper h-fit last:!mb-8 tablet-portrait:last:mb-4 -ms-1.5 ps-1.5 -me-3 pe-3.5",attrs:{"data-cid":post.cid,"data-id":post.id}},[_c(_setup.SurfacePost,{class:[
            // Exclude this component from using styles in app/assets/stylesheets/3/surface/show/layouts/grid.scss
            'wish-v2',
            _setup.isPostSizeStandard && 'max-w-64',
            _setup.isPostSizeWide && 'max-w-95',
          ],attrs:{"index":index,"post":post,"post-reaction-ids":post.id ? _vm.reactionIdsByPostId[post.id] : [],"post-comment-ids":post.id ? _vm.commentIdsByPostId[post.id] : []}})],1)}),0)])}),_vm._v(" "),(_setup.wishGroupBy === _setup.GroupByTypes.Section && _setup.canIModerate && !_setup.isReadOnly)?_c('div',{key:"surface-add-section-button",staticClass:"flex-none flex flex-col items-start justify-end me-auto w-fit mt-2",style:({ height: `${_setup.maxPostGroupHeaderHeight}px`, marginInlineEnd: 'auto' })},[_c(_setup.SurfaceAddSectionButton,{staticClass:"mb-11 tablet-portrait:mb-12"})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }